(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxRemoveSecureGroups(
    GroupModel, GroupListService, $filter, toastr
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/secureSettings/removeSecureGroups/removeSecureGroups.template.html',
      link: function(scope) {

        scope.groupList = [];
        scope.selectedGroups = [];
        var customKeyBinding = false;

        (function() {
          customKeyBinding = true;
          prepareGroups();
        })();

        function prepareGroups () {
          var groups = scope.tenant.info._embedded.securePrintConfiguration._embedded[scope.context.groups];
          angular.forEach(groups, function (group) {
            var newGroup = new GroupModel(group);
            scope.groupList.push(newGroup);
          })

          scope.groupsList = groups
        }

        document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (customKeyBinding){
            switch (evt.keyCode) {
              case 38:
                evt.preventDefault();
                if (document.activeElement.previousElementSibling) {
                  document.activeElement.previousElementSibling.focus();
                }
              break;
              case 40:
                evt.preventDefault();
                if (document.activeElement.nextElementSibling) {
                  document.activeElement.nextElementSibling.focus();
                }
              break;
            }
          }
        };

        scope.toggleSelectGroup = function (event, group) {
          event.stopPropagation()
          event.preventDefault()
          if (!group.options.isSelected) {
            group.options.isSelected = true
            scope.selectedGroups.push(group);
          } else {
            group.options.isSelected = false
            scope.deselectGroup(event, group);
          }

          if (scope.selectedGroups.length < 1) {
            scope.noGroupSelected = true;
          } else {
            scope.noGroupSelected = false;
          }
        }

        scope.toggleUnselectGroup = function (event, group) {
          event.stopPropagation()
          event.preventDefault()

          if (!group.options.isSelected) {
            group.options.isSelected = true
            scope.unSelectedGroups.push(group);
          } else {
            group.options.isSelected = false
            scope.deselectGroup(event, group);
          }

          if (scope.unSelectedGroups.length < 1) {
            scope.noGroupSelected = true;
          } else {
            scope.noGroupSelected = false;
          }
        }

        scope.deselectGroup =  function (event, group) {
          if (group.info) {
            for (var i = 0; i < scope.selectedGroups.length; i++) {
              if (group.info._links.self.href === scope.selectedGroups[i].info._links.self.href) {
                scope.selectedGroups.splice(i, 1);
              }
            }
          } else {
            for (var i = 0; i < scope.unSelectedGroups.length; i++) {
              if (group._links.self.href === scope.unSelectedGroups[i]._links.self.href) {
                scope.unSelectedGroups.splice(i, 1);
              }
            }
          }

        }

        scope.closePopup = function () {
          scope.callback();
        }

        scope.saveChanges = function () {
          addGroups();
        }


        function addGroups () {
          var url = scope.tenant.info._embedded.securePrintConfiguration._links[scope.context.link].href;
          var groupIDsAdd = [];
          angular.forEach(scope.selectedGroups, function(group) {
            groupIDsAdd.push(group.info._links.self.href);
          })


          var postObjectAdd = {
            type: 'DELETE',
            groups: groupIDsAdd
          }


          if (scope.context.securityLevel) {
            url = url.replace('{securityLevel}', scope.context.securityLevel);
            postObjectAdd.securityLevel = scope.context.securityLevel
          }

          var postObjectWrapper = []
          if (postObjectAdd.groups.length > 0) {
            postObjectWrapper.push(postObjectAdd);
          }

          GroupListService.addSecuritySettingOnGroups(url, postObjectWrapper).then(function() {
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function(error){
            toastr.error($filter("translate")("ERROR"));
          });
          scope.callback();

        }

        scope.$on('$destroy', function() {
          angular.element('.pagination-content').off('scroll');
          customKeyBinding = false;
        });

      }
    };
  }

  pxRemoveSecureGroups.$inject = ['GroupModel', 'GroupListService', '$filter', 'toastr'];

  angular
    .module('printix-admin')
    .directive('pxRemoveSecureGroups', pxRemoveSecureGroups);

})();
